<template>
  <div ref="ganttContainer" id="gantt-container"></div>
</template>

<script>
import { gantt } from "dhtmlx-gantt";
import { formatDate } from "@/utils";

export default {
  name: "ganttContainer",
  props: {
    tasks: {
      type: Object,
      default() {
        return { data: [], links: [] };
      }
    },
    PerpectiveId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      employees: [],
      Perpectives: {
        1: { Value: 1, Label: "Financiera", Color: "rgba(168, 211, 240 )" },
        2: { Value: 2, Label: "Del cliente", Color: "rgba(195, 240, 168)" },
        3: {
          Value: 3,
          Label: "Procesos inter",
          Color: "rgba(240, 234, 168)"
        },
        4: {
          Value: 4,
          Label: "Des y Aprendi",
          Color: "rgba(220, 168, 240 )"
        }
      },
      textFilter: ""
    };
  },
  methods: {
    CopyandPasteTasks() {
      gantt.plugins({
        keyboard_navigation: true,
        multiselect: true
      });

      let tasks_to_copy = [];

      gantt.ext.keyboardNavigation.addShortcut(
        "ctrl+c",
        function () {
          tasks_to_copy = [];
          gantt.eachSelectedTask(function (task_id) {
            tasks_to_copy.push(task_id);
          });
        },
        "taskRow"
      );
      gantt.ext.keyboardNavigation.addShortcut(
        "ctrl+v",
        function () {
          const new_parent = gantt.getSelectedId();
          for (let i = 0; i < tasks_to_copy.length; i++) {
            const task = gantt.copy(gantt.getTask(tasks_to_copy[i]));

            task.id = +new Date() + "+" + Math.floor(Math.random() * 10);
            gantt.addTask(task, new_parent);
          }
          gantt.getTask(new_parent).$open = true;
          gantt.render();
        },
        "taskRow"
      );
    },
    progressTaks() {
      gantt.templates.progress_text = function (start, end, task) {
        return (
          "<span style='text-align:left;'>" +
          Math.round(task.progress * 100) +
          "% </span>"
        );
      };
    },
    getColumns() {
      let thiss = this;

      if (thiss.PerpectiveId != 0 && thiss.PerpectiveId != "") {
        gantt.config.columns = [
          { name: "add", width: 44 },
          {
            name: "id",
            label: `<input id='filter' placeholder='Search tasks...' style='width: 120px;' />`,
            tree: true,
            width: 210,
            resize: true,
            template: function (task) {
              return "#" + task.id;
            }
          },
          {
            name: "text",
            label: "Objetivo",
            width: 250,
            resize: true
          },
          {
            name: "progress",
            label: "Progreso",
            width: 80,
            resize: true,
            align: "center",
            template: function (task) {
              if (task.progress == 100)
                return `<el-tag style="color: green; font-weight:bold; background-color:rgba(87, 255, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">${
                  task.progress + "%"
                }</el-tag>`;
              else if (task.progress == 75)
                return `<el-tag style="color: blue; font-weight:bold; background-color:rgba(29, 255, 255, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">${
                  task.progress + "%"
                }</el-tag>`;
              else if (task.progress == 50)
                return `<el-tag style="color: black; font-weight:bold; background-color:rgba(504, 95, 52, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">${
                  task.progress + "%"
                }</el-tag>`;
              else
                return `<el-tag style="color: red; font-weight:bold; background-color:rgba(255, 29, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">${
                  task.progress + "%"
                }</el-tag>`;
            }
          },
          {
            name: "read",
            label: "Estado",
            width: 95,
            align: "center",
            resize: true,
            template: function (task) {
              if (task.parent != 0) {
                if (task.read == false) {
                  return `<el-tag  style=" font-weight: bold; color:green; background-color:rgba(195, 240, 168, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                     New
                    </el-tag>`;
                } else if (
                  task.end_date < Date.now() &&
                  task.approved == 1 &&
                  task.read == true
                ) {
                  return `<el-tag  style="  font-weight: bold; color:red; background-color:rgba(255, 29, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                  P
                  </el-tag>`;
                } else if (task.approved == 1 && task.read == true) {
                  return `<el-tag style=" font-weight: bold; color:#987c06; background-color:rgba(252, 234, 8, 0.2 ); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                      P
                </el-tag>`;
                } else if (task.approved == 2 && task.read == true) {
                  return "Cerrada";
                } else if (task.approved == 3 && task.read == true) {
                  return `<el-tag style=" font-weight: bold; color:green; background-color:rgba(195, 240, 168, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                  ✔️
                </el-tag>`;
                } else if (
                  task.approved == 3 &&
                  task.read == true &&
                  task.close_date > task.end_date
                ) {
                  return `<el-tag style=" font-weight: bold; color:red; background-color:rgba(255, 29, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                  ✔️
                </el-tag>`;
                }
              } else {
                if (task.read == false) {
                  return `<el-tag  style=" font-weight: bold; color:green; background-color:rgba(195, 240, 168, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                  New
                  </el-tag>`;
                } else if (task.progress == 100) {
                  return "✔️";
                }
                return `<el-tag style=" font-weight: bold; color:#987c06; background-color:rgba(252, 234, 8, 0.2 ); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
               P
              </el-tag>`;
              }
              return;
            }
          },
          {
            name: "owner",
            align: "left",
            width: 120,
            label: "Responsable",
            template: function (task) {
              // var store = gantt.getDatastore("resource");
              // var owner = store.getItem(task.owner_id);
              return `
                <div style="display: flex">
                  <img src="${task.image_owner}" style="border-radius: 50%; width: 30%; height: 90%; margin-top: 3px; margin-bottom: 2px; margin-right: 2px;"/>
                  <label> ${task.owner_name} </label>
                </div>`;
              // if (owner) {
              //   return `
              //     <div style="display: flex">
              //       <img src="${task.image_created}" style="border-radius: 50%; width: 30%; height: 90%; margin-top: 3px; margin-bottom: 2px; margin-right: 2px;"/>
              //       <label> ${task.created_name} </label>
              //     </div>`;
              // } else {
              //   return "Unassigned";
              // }
            },
            resize: true
          },
          {
            name: "created",
            align: "left",
            width: 120,
            label: "Creado",
            resize: true,
            template: function (task) {
              // var store = gantt.getDatastore("resource");
              // var owner = store.getItem(task.owner_id);
              return `
                <div style="display: flex">
                  <img src="${task.image_created}" style="border-radius: 50%; width: 30%; height: 90%; margin-top: 3px; margin-bottom: 2px; margin-right: 2px;"/>
                  <label> ${task.created_name} </label>
                </div>`;
            }
          },
          {
            name: "type",
            label: "Tipo Perspectiva",
            width: 210,
            align: "center",
            resize: true,
            template: function (task) {
              if (task.type) {
                // return thiss.Perpectives[task.type].Label;
                return `<el-tag style=" font-weight:bold ; background-color:${
                  thiss.Perpectives[task.type].Color
                }; border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                ${thiss.Perpectives[task.type].Label}
              </el-tag>`;
              }
            }
          },
          {
            name: "start_date",
            label: "Fecha Inicio",
            align: "center",
            width: 110,
            resize: true,
            template: function (task) {
              // console.log("aa", task);
              return formatDate(task.start_date, "DD/MM/YYYY");
            }
          },
          {
            name: "end_date",
            label: "Fecha Final",
            align: "center",
            width: 110,
            resize: true,
            template: function (task) {
              // console.log("aa", task);
              return formatDate(task.end_date, "DD/MM/YYYY");
            }
          },
          {
            name: "duration",
            label: "Duracción",
            width: 70,
            align: "center",
            resize: true
          },
          {
            name: "type_strategic",
            label: "Tipo",
            width: 110,
            align: "center",
            resize: true,
            template: function (task) {
              if (task.parent != 0) {
                var taskOriginal = gantt.getTaskBy("id", task.parent);
                // return thiss.Perpectives[taskOriginal[0].type].Label;
                return taskOriginal[0].type_strategic == 1
                  ? `<el-tag style=" font-weight: bold; color:#987c06; background-color:rgba(252, 234, 8, 0.2 ); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                Operacional
              </el-tag>`
                  : `<el-tag style=" font-weight:bold; color: rgba(246, 97, 228); background-color:rgba(246, 97, 228, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                Estrátegico
              </el-tag>`;
              }
              return task.type_strategic == 1
                ? `<el-tag style=" font-weight: bold; color:#987c06; background-color:rgba(252, 234, 8, 0.2 ); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                Operacional
              </el-tag>`
                : `<el-tag style=" font-weight:bold; color: rgba(246, 97, 228); background-color:rgba(246, 97, 228, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                Estrátegico
              </el-tag>`;
            }
          }
        ];
        return;
      }
      gantt.config.columns = [
        {
          name: "id",
          label: `<input id='filter' placeholder='Search tasks...' style='width: 120px;' />`,
          tree: true,
          width: 210,
          resize: true,
          template: function (task) {
            return "#" + task.id;
          }
        },
        {
          name: "text",
          label: "Objetivo",
          width: 250,
          resize: true
        },
        {
          name: "progress",
          label: "Progreso",
          width: 80,
          resize: true,
          align: "center",
          template: function (task) {
            if (task.progress == 100)
              return `<el-tag style="color: green; font-weight:bold; background-color:rgba(87, 255, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">${
                task.progress + "%"
              }</el-tag>`;
            else if (task.progress == 75)
              return `<el-tag style="color: blue; font-weight:bold; background-color:rgba(29, 255, 255, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">${
                task.progress + "%"
              }</el-tag>`;
            else if (task.progress == 50)
              return `<el-tag style="color: black; font-weight:bold; background-color:rgba(504, 95, 52, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">${
                task.progress + "%"
              }</el-tag>`;
            else
              return `<el-tag style="color: red; font-weight:bold; background-color:rgba(255, 29, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">${
                task.progress + "%"
              }</el-tag>`;
          }
        },
        {
          name: "read",
          label: "Estado",
          width: 95,
          align: "center",
          resize: true,
          template: function (task) {
            if (task.parent != 0) {
              if (task.read == false) {
                return `<el-tag  style=" font-weight: bold; color:green; background-color:rgba(195, 240, 168, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                     New
                    </el-tag>`;
              } else if (
                task.end_date < Date.now() &&
                task.approved == 1 &&
                task.read == true
              ) {
                return `<el-tag  style="  font-weight: bold; color:red; background-color:rgba(255, 29, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                  P
                  </el-tag>`;
              } else if (task.approved == 1 && task.read == true) {
                return `<el-tag style=" font-weight: bold; color:#987c06; background-color:rgba(252, 234, 8, 0.2 ); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                      P
                </el-tag>`;
              } else if (task.approved == 2 && task.read == true) {
                return "Cerrada";
              } else if (task.approved == 3 && task.read == true) {
                return `<el-tag style=" font-weight: bold; color:green; background-color:rgba(195, 240, 168, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                  ✔️
                </el-tag>`;
              } else if (
                task.approved == 3 &&
                task.read == true &&
                task.close_date > task.end_date
              ) {
                return `<el-tag style=" font-weight: bold; color:red; background-color:rgba(255, 29, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                  ✔️
                </el-tag>`;
              }
            } else {
              if (task.read == false) {
                return `<el-tag  style=" font-weight: bold; color:green; background-color:rgba(195, 240, 168, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                  New
                  </el-tag>`;
              } else if (task.progress == 100) {
                return "✔️";
              }
              return `<el-tag style=" font-weight: bold; color:#987c06; background-color:rgba(252, 234, 8, 0.2 ); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
               P
              </el-tag>`;
            }
            return;
          }
        },
        {
          name: "owner",
          align: "left",
          width: 120,
          label: "Responsable",
          template: function (task) {
            // var store = gantt.getDatastore("resource");
            // var owner = store.getItem(task.owner_id);
            return `
                <div style="display: flex">
                  <img src="${task.image_owner}" style="border-radius: 50%; width: 30%; height: 90%; margin-top: 3px; margin-bottom: 2px; margin-right: 2px;"/>
                  <label> ${task.owner_name} </label>
                </div>`;
          },
          resize: true
        },
        {
          name: "created",
          align: "left",
          width: 120,
          label: "Creado",
          resize: true,
          template: function (task) {
            // var store = gantt.getDatastore("resource");
            // var owner = store.getItem(task.owner_id);
            return `
                <div style="display: flex">
                  <img src="${task.image_created}" style="border-radius: 50%; width: 30%; height: 90%; margin-top: 3px; margin-bottom: 2px; margin-right: 2px;"/>
                  <label> ${task.created_name} </label>
                </div>`;
            // if (owner) {
            //   return `
            //     <div style="display: flex">
            //       <img src="${task.image_created}" style="border-radius: 50%; width: 30%; height: 90%; margin-top: 3px; margin-bottom: 2px; margin-right: 2px;"/>
            //       <label> ${task.created_name} </label>
            //     </div>`;
            // } else {
            //   return "Unassigned";
            // }
          }
        },
        {
          name: "type",
          label: "Tipo Perspectiva",
          width: 210,
          align: "center",
          resize: true,
          template: function (task) {
            if (task.type) {
              // return thiss.Perpectives[task.type].Label;
              return `<el-tag style=" font-weight:bold ; background-color:${
                thiss.Perpectives[task.type].Color
              }; border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                ${thiss.Perpectives[task.type].Label}
              </el-tag>`;
            }
          }
        },
        {
          name: "start_date",
          label: "Fecha Inicio",
          align: "center",
          width: 110,
          resize: true,
          template: function (task) {
            // console.log("aa", task);
            return formatDate(task.start_date, "DD/MM/YYYY");
          }
        },
        {
          name: "end_date",
          label: "Fecha Final",
          align: "center",
          width: 110,
          resize: true,
          template: function (task) {
            // console.log("aa", task);
            return formatDate(task.end_date, "DD/MM/YYYY");
          }
        },
        {
          name: "duration",
          label: "Duracción",
          width: 70,
          align: "center",
          resize: true
        },
        {
          name: "type_strategic",
          label: "Tipo",
          width: 110,
          align: "center",
          resize: true,
          template: function (task) {
            if (task.parent != 0) {
              var taskOriginal = gantt.getTaskBy("id", task.parent);
              // return thiss.Perpectives[taskOriginal[0].type].Label;
              return taskOriginal[0].type_strategic == 1
                ? `<el-tag style=" font-weight: bold; color:#987c06; background-color:rgba(252, 234, 8, 0.2 ); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                Operacional
              </el-tag>`
                : `<el-tag style=" font-weight:bold; color: rgba(246, 97, 228); background-color:rgba(246, 97, 228, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                Estrátegico
              </el-tag>`;
            }
            return task.type_strategic == 1
              ? `<el-tag style=" font-weight: bold; color:#987c06; background-color:rgba(252, 234, 8, 0.2 ); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                Operacional
              </el-tag>`
              : `<el-tag style=" font-weight:bold; color: rgba(246, 97, 228); background-color:rgba(246, 97, 228, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;">
                Estrátegico
              </el-tag>`;
          }
        }
      ];
    },
    getEmployees() {
      let uri = "";
      const company = this.currentCompany;
      const employeeId = this.currentUser.EmployeeId;

      uri = `/api/CMI/Objetives/GetUsersObjetivos?CompanySelected=${company}&employeeid=${employeeId}`;

      this.$http
        .get(uri)
        .then((response) => {
          this.employees = response.data;
        })
        .catch(() => {});
    },
    GetOwners() {
      gantt.locale.labels.section_description = "Descripción";
      gantt.locale.labels.section_owner = "Responsable";
      gantt.locale.labels.section_progress = "Progreso";
      gantt.config.lightbox.sections = [
        {
          name: "description",
          height: 38,
          map_to: "text",
          type: "textarea",
          focus: true
        },
        {
          name: "owner",
          height: 22,
          map_to: "owner_id",
          type: "select",
          options: gantt.serverList("people")
        },
        {
          name: "progress",
          height: 22,
          map_to: "progress",
          type: "select",
          options: this.listProgress
        },
        { name: "time", type: "duration", map_to: "auto" }
      ];

      gantt.config.resource_store = "resource";
      gantt.config.resource_property = "owner_id";
      gantt.config.order_branch = true;
      gantt.config.open_tree_initially = true;
      gantt.config.grid_resize = true;

      var resourcesStore = gantt.createDatastore({
        name: gantt.config.resource_store,
        type: "treeDatastore",
        initItem: function (item) {
          item.parent = item.parent || gantt.config.root_id;
          item[gantt.config.resource_property] = item.parent;
          item.open = true;
          return item;
        }
      });

      resourcesStore.attachEvent("onParse", function () {
        var people = [];
        resourcesStore.eachItem(function (res) {
          if (!resourcesStore.hasChild(res.id)) {
            var copy = gantt.copy(res);
            copy.key = res.id;
            copy.label = res.text;
            people.push(copy);
          }
        });
        gantt.updateCollection("people", people);
      });

      resourcesStore.parse(this.employees);
    },
    toolTipsCells() {
      gantt.ext.tooltips.tooltipFor({
        selector: ".gantt_task_cell",
        html: function (event) {
          var id = event.target.parentNode.attributes["task_id"].nodeValue;
          var task = gantt.getTask(id);
          return task.text;
        }
      });
    },
    // searchTask() {
    //   var filterValue = "";
    //   gantt.$doFilter = function (value) {
    //     filterValue = value;
    //     gantt.refreshData();
    //   };

    //   gantt.attachEvent("onBeforeTaskDisplay", function (id, task) {
    //     if (!filterValue) return true;

    //     var normalizedText = task.id;
    //     var normalizedValue = filterValue;
    //     return normalizedText.indexOf(normalizedValue) > -1;
    //   });

    //   gantt.attachEvent("onGanttRender", function () {
    //     gantt.$root.querySelector("[data-text-filter]").value = filterValue;
    //   });
    // },
    filterTask() {
      // let filterValue = "";
      let thiss = this;
      gantt.attachEvent("onGanttRender", async function () {
        thiss.textFilter = "";

        const filterEl = await document.querySelector("#filter");
        // console.log("ooo", filterEl);
        if (filterEl) {
          await filterEl.addEventListener("input", function () {
            thiss.textFilter = filterEl.value;
            gantt.refreshData();
          });
          return;
        }
        gantt.refreshData();
      });

      gantt.attachEvent("onBeforeTaskDisplay", function (id, task) {
        if (!thiss.textFilter) {
          return true;
        }
        return filterLogic(task);
      });

      function filterLogic(task, match) {
        match = match || false;
        // check children
        gantt.eachTask(function (child) {
          if (filterLogic(child)) {
            match = true;
          }
        }, task.id);

        // // check children
        // gantt.eachParent(function (parent) {
        //   if (filterLogic(parent)) {
        //     match = true;
        //   }
        // }, task.id);

        // check task
        if (
          task.text.toLowerCase().indexOf(thiss.textFilter.toLowerCase()) >
            -1 ||
          task.id.toLowerCase().indexOf(thiss.textFilter.toLowerCase()) > -1
        ) {
          match = true;
        }
        return match;
      }
    }
  },
  watch: {
    PerpectiveId() {
      this.getColumns();
    }
  },
  async mounted() {
    gantt.plugins({
      tooltip: true,
      quick_info: true,
      keyboard_navigation: true
    });
    // gantt.config.scroll_on_click = true;
    gantt.config.date_format = "%Y-%m-%d";
    // gantt.config.initial_scroll = true;
    gantt.config.quickinfo_buttons = ["icon_edit"];
    gantt.i18n.setLocale("es");
    gantt.config.sort = true;
    gantt.templates.grid_row_class = function (start, end, task) {
      if (task.parent == 0) {
        return "colorObjective";
      } else if (task.parent.includes("Task")) {
        return "colorSubTask";
      }
      return "colorTask";
    };

    this.getEmployees();
    // this.scroll();
    this.getColumns();
    this.CopyandPasteTasks();
    this.progressTaks();
    gantt.init(this.$refs.ganttContainer);
    gantt.parse(this.$props.tasks);
    this.toolTipsCells();
    // this.searchTask();
    this.$nextTick(() => {
      this.filterTask();
    });
  }
};
</script>

<style lang="css" scoped>
el-tag {
  font-weight: bold;
  font-family: "Nunito Sans", "Helvetica", "Arial", "sans-serif";
}
/* @import "~dhtmlx-gantt/codebase/dhtmlxgantt.css"; */
/* @import "~dhtmlx-gantt/codebase/sources/dhtmlxgantt.css"; */
/* @import "../../../../../gantt_8.0.1_individual/codebase/skins/dhtmlxgantt_broadway.css"; */
/* @import "../../../../../gantt_8.0.1_individual/codebase/skins/dhtmlxgantt_material.css"; */
/* @import "../../../../../gantt_8.0.1_individual/codebase/skins/dhtmlxgantt_skyblue.css"; */
@import "./ganttSTYLE.css";
</style>
